<template>
    <article class="widget default">
        <template v-if="busy">
            <CenteredMessage :spinner="true">
                <template>Erstellt Widget...</template>
            </CenteredMessage>
        </template>
        <template v-else>
            <div class="text-center px-1 py-5">
                Neues Widget hinzufügen
                <br />
                <b-dropdown variant="link" class="db–dropdown">
                    <template v-slot:button-content>
                        <font-awesome-icon icon="plus" />
                    </template>
                    <template v-if="collection.length > 0">
                        <b-dropdown-item
                            v-for="widget in collection"
                            :key="widget.id"
                            @click="selectWidget(widget.id)"
                            >{{ widget.nicename }}</b-dropdown-item
                        >
                    </template>
                    <template v-else>
                        <b-dropdown-text
                            >Keine Widgets verfügbar</b-dropdown-text
                        >
                    </template>
                </b-dropdown>
            </div>
        </template>
    </article>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Widget from "@/mixins/Widget/Widget";

import "./Widget.scss";

const WidgetApi = ApiFactory.get("widgets");

export default {
    name: "DefaultWidget",
    props: ["rank", "updated"],
    mixins: [Widget],
    data() {
        return {
            collection: []
        };
    },
    created() {
        this.fetchCollection();
    },
    mounted() {
        this.$root.$on("mv::widgets::update", (id, rank) => {
            if (this.rank !== rank) {
                this.collection = this.collection.filter(item => {
                    return item.id !== id;
                });
            }
        });
        this.$root.$on("mv::widgets::remove", widget => {
            if (this.rank !== widget.rank) {
                const check = this.collection.find(
                    item => item.id === widget.id
                );
                if (!check) {
                    this.collection.push(widget);
                    this.collection.sort(this.sortWidgetCollection);
                }
            }
        });
    },
    methods: {
        async fetchCollection() {
            const response = await WidgetApi.getCollection();
            if (response.ok) {
                this.collection = response.json.collection;
            }
        },
        selectWidget(id) {
            this.$root.$emit("mv::widgets::update", id, this.rank);
            this.$emit("update", id, this.rank);
            this.busy = true;
        },
        sortWidgetCollection(a, b) {
            if (a.nicename < b.nicename) {
                return -1;
            }
            if (a.nicename > b.nicename) {
                return 1;
            }
            return 0;
        }
    }
};
</script>
